/** Approximate lon/lat for market dots. Missing codes fall back to region anchors. */

export const ISO2_LONLAT: Record<string, [number, number]> = {
  US: [-98, 39], CA: [-96, 56], MX: [-102, 23], GT: [-90, 15], BZ: [-88, 17],
  HN: [-86, 15], SV: [-89, 14], NI: [-85, 13], CR: [-84, 10], PA: [-80, 9],
  CU: [-79, 22], JM: [-77, 18], HT: [-72, 19], DO: [-70, 19], PR: [-66, 18],
  TT: [-61, 10], BB: [-59, 13], BS: [-78, 24],
  BR: [-51, -10], AR: [-64, -34], CL: [-71, -30], CO: [-74, 4], PE: [-75, -10],
  VE: [-66, 7], EC: [-78, -1], BO: [-65, -17], PY: [-58, -23], UY: [-56, -33],
  GY: [-59, 5], SR: [-56, 4],
  GB: [-2, 54], IE: [-8, 53], FR: [2, 47], ES: [-4, 40], PT: [-8, 40],
  DE: [10, 51], NL: [5, 52], BE: [4, 51], LU: [6, 50], CH: [8, 47], AT: [14, 47],
  IT: [12, 43], PL: [19, 52], CZ: [15, 50], SK: [19, 49], HU: [19, 47],
  RO: [25, 46], BG: [25, 43], GR: [22, 39], HR: [16, 45], SI: [15, 46],
  RS: [21, 44], BA: [18, 44], ME: [19, 43], AL: [20, 41], MK: [22, 42],
  UA: [31, 49], BY: [28, 53], LT: [24, 55], LV: [25, 57], EE: [26, 59],
  SE: [15, 62], NO: [9, 61], FI: [26, 64], DK: [10, 56], IS: [-19, 65],
  RU: [90, 60],
  NG: [8, 10], GH: [-1, 8], KE: [38, 1], ZA: [24, -29], EG: [30, 27],
  MA: [-7, 32], DZ: [3, 28], TN: [9, 34], LY: [17, 27], SD: [30, 16],
  ET: [40, 9], TZ: [35, -6], UG: [32, 1], RW: [30, -2], BI: [30, -3],
  AO: [18, -12], MZ: [35, -18], ZW: [30, -19], ZM: [28, -15], BW: [24, -22],
  NA: [17, -22], SN: [-14, 14], CI: [-5, 8], CM: [12, 6], CD: [24, -3],
  CG: [15, -1], GA: [12, -1], ML: [-4, 17], NE: [8, 17], TD: [19, 15],
  SO: [46, 6], SS: [30, 7], LR: [-9, 6], SL: [-12, 8], GM: [-15, 13],
  GN: [-11, 11], BJ: [2, 9], TG: [1, 8], BF: [-2, 12], MW: [34, -13],
  LS: [28, -29], SZ: [31, -26], MG: [47, -19], MU: [57, -20],
  CV: [-24, 16],
  CN: [104, 35], IN: [79, 22], JP: [138, 36], KR: [128, 36], ID: [118, -2],
  PH: [122, 12], VN: [108, 16], TH: [101, 15], MY: [102, 4], SG: [104, 1],
  MM: [96, 21], KH: [105, 13], LA: [102, 18], BD: [90, 24], PK: [69, 30],
  AF: [66, 34], NP: [84, 28], LK: [81, 7], MN: [105, 47], KZ: [66, 48],
  UZ: [64, 41], TM: [59, 39], KG: [75, 41], TJ: [71, 39],
  AU: [134, -25], NZ: [174, -41], PG: [144, -6], FJ: [178, -18],
  SA: [45, 24], AE: [54, 24], QA: [51, 25], KW: [48, 29], BH: [51, 26],
  OM: [56, 21], YE: [48, 16], IQ: [44, 33], IR: [53, 32], IL: [35, 31],
  JO: [36, 31], LB: [36, 34], SY: [39, 35], TR: [35, 39],
  GE: [44, 42], AM: [45, 40], AZ: [48, 40],
  TW: [121, 24], HK: [114, 22], MO: [113, 22],
  GL: [-42, 72], AQ: [0, -80],
};

export const REGION_LONLAT: Record<string, [number, number]> = {
  'North America': [-100, 48],
  'Latin America': [-60, -12],
  Europe: [15, 50],
  Africa: [20, 4],
  Asia: [95, 28],
  Oceania: [145, -22],
  'Middle East': [45, 26],
  Other: [10, 10],
};

export function lonLatFor(iso2: string, region: string): [number, number] {
  const known = ISO2_LONLAT[iso2.toUpperCase()];
  if (known) return known;
  const [lon, lat] = REGION_LONLAT[region] ?? REGION_LONLAT.Other;
  const n = iso2.charCodeAt(0) + iso2.charCodeAt(1) * 13;
  return [lon + ((n % 17) - 8) * 1.6, lat + ((n % 11) - 5) * 1.2];
}

export function projectLonLat(lon: number, lat: number, width: number, height: number): [number, number] {
  const x = ((lon + 168) / 372) * width;
  const y = ((78 - lat) / 140) * height;
  return [x, y];
}
